import { Theme } from '@mui/material/styles'

const muiPaper = (theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        outline: 0,
        '&.MuiAutocomplete-paper': {
          borderRadius: 12,
          border: `1px solid ${theme.colors.stroke}`
        },
        '&.MuiDialog-paper ': {
          borderRadius: '1rem'
        }
      }
    }
  }
}

export default muiPaper
